import type { KatalogAttribut } from '../gql/graphql.ts';
import { Attribut } from './Attribut.tsx';
import type { PopoverSeite } from './InfoPopover.tsx';

type AttributListeProps = {
  attribute: KatalogAttribut[];
  gewaehlteAttribute: string[];
  infoSeite: PopoverSeite;
  className?: string;
  onToggle: (attributName: string) => void;
};

export function AttributListe({
  attribute,
  gewaehlteAttribute,
  infoSeite,
  className,
  onToggle,
}: AttributListeProps) {
  return (
    <div
      className={`grid grid-cols-1 gap-x-11 gap-y-2 sm:grid-cols-2 lg:grid-cols-3 ${
        className ?? ''
      }`}>
      {attribute.map((attribut) => (
        <Attribut
          key={attribut.name}
          attribut={attribut}
          gewaehlt={gewaehlteAttribute.includes(attribut.name)}
          infoSeite={infoSeite}
          onToggle={() => onToggle(attribut.name)}
        />
      ))}
    </div>
  );
}
